import { render } from "./MyCards.vue?vue&type=template&id=6f928694&scoped=true"
import script from "./MyCards.vue?vue&type=script&lang=js"
export * from "./MyCards.vue?vue&type=script&lang=js"

import "./MyCards.vue?vue&type=style&index=0&id=6f928694&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f928694"]])

export default __exports__